import React, { Component } from "react";
import * as Icon from "react-feather";
import MessageCard from "./MessageCard";

function decodeEntities(s) {
	if (!s) return "";
	return s.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}

// Hide the very common system labels in the pill row; show only user/custom ones + INBOX/STARRED/IMPORTANT
const HIDE_LABELS = new Set(["UNREAD", "CATEGORY_PERSONAL", "CATEGORY_SOCIAL", "CATEGORY_PROMOTIONS", "CATEGORY_UPDATES", "CATEGORY_FORUMS", "SENT"]);

function prettyLabel(l) {
	if (!l) return l;
	if (l === "INBOX") return "Inbox";
	if (l === "STARRED") return "Starred";
	if (l === "IMPORTANT") return "Important";
	if (l === "DRAFT") return "Draft";
	if (l === "TRASH") return "Trash";
	if (l === "SPAM") return "Spam";
	if (l.startsWith("Label_")) return l.replace("Label_", "");
	return l;
}

class ThreadView extends Component {
	render() {
		const { thread, loading, error, accountId, onToggleStarred, onTrash, onClose, onReply, onForward } = this.props;

		if (loading) {
			return (
				<div className="thread-view">
					<div className="inbox__empty">
						<span className="inbox-spinner" />
						<p style={{ marginTop: 14 }}>Loading conversation…</p>
					</div>
				</div>
			);
		}

		if (error) {
			return (
				<div className="thread-view">
					<div className="inbox__empty">
						<Icon.AlertCircle size={36} />
						<h3>Could not load conversation</h3>
						<p>{error}</p>
					</div>
				</div>
			);
		}

		if (!thread) {
			return (
				<div className="thread-view">
					<div className="inbox__empty">
						<Icon.Mail size={48} />
						<h3>Select a conversation</h3>
						<p>Choose a message on the left to read it here.</p>
					</div>
				</div>
			);
		}

		const messages = thread.messages || [];
		const lastIdx = messages.length - 1;
		const anyStarred = messages.some(m => m.isStarred);
		const labelsUnion = Array.from(new Set(messages.flatMap(m => m.labels || []))).filter(l => !HIDE_LABELS.has(l));

		return (
			<div className="thread-view">
				<div className="thread-view__header">
					<div className="thread-view__title-row">
						<h1 className="thread-view__title">{decodeEntities(thread.subject) || "(no subject)"}</h1>
						<div className="thread-view__actions">
							<button
								className={`thread-view__icon-btn${anyStarred ? " is-starred" : ""}`}
								onClick={onToggleStarred}
								title={anyStarred ? "Unstar" : "Star"}
							>
								<Icon.Star size={18} />
							</button>
							<button className="thread-view__icon-btn" onClick={onReply} title="Reply">
								<Icon.CornerUpLeft size={18} />
							</button>
							<button className="thread-view__icon-btn" onClick={onForward} title="Forward">
								<Icon.CornerUpRight size={18} />
							</button>
							<button className="thread-view__icon-btn" onClick={onTrash} title="Move to trash">
								<Icon.Trash2 size={18} />
							</button>
							<button className="thread-view__icon-btn" onClick={onClose} title="Close">
								<Icon.X size={18} />
							</button>
						</div>
					</div>
					{labelsUnion.length > 0 && (
						<div className="thread-view__labels">
							{labelsUnion.map(l => (
								<span key={l} className="label-pill">
									{prettyLabel(l)}
								</span>
							))}
						</div>
					)}
				</div>

				<div className="thread-view__messages">
					{messages.map((m, idx) => (
						<MessageCard
							key={m.id}
							message={m}
							accountId={accountId}
							expanded={idx === lastIdx}
							onToggleStar={this.props.onToggleMessageStar}
						/>
					))}
					<div className="thread-view__reply-cta">
						<button className="thread-view__cta-btn" onClick={onReply}>
							<Icon.CornerUpLeft size={14} /> Reply
						</button>
						<button className="thread-view__cta-btn thread-view__cta-btn--ghost" onClick={onForward}>
							<Icon.CornerUpRight size={14} /> Forward
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default ThreadView;
